<i18n src="@/locales/modules/ActivityTranslate.json"></i18n>

<template>
	<el-dialog append-to-body class="custom-dialog filter-dialog" :title="$t('Filter')" :visible.sync="isDialogActiveLocal">
		<PerfectScrollbar ref="vueScrollBar" :settings="settings" class="scroll-area--data-list p-6">
			<!-- Time -->
			<div class="request-filter__item">
				<legend class="uppercase-first-letter text-solid-gray-1">{{ $t("Time") }}:</legend>
				<cbs-date-picker
					clearable
					v-model="localValue.DateStart"
					class="w-full"
					type="datetime"
					format="dd/MM/yyyy HH:mm:ss"
					value-format="yyyy-MM-dd HH:mm:ss"
					:name="`detectDate`"
					:placeholder="`${$t('Actions.Choose')} ${$t('Time').toLowerCase()}`"
					@change="changeDetectDate"
				/>
			</div>

			<!-- Student -->
			<div class="mt-6" >
				<legend class="uppercase-first-letter text-solid-gray-1">{{ $t("Student") }}:</legend>
				<cbs-relations-humanroles
					:data-vv-as="$t('Employee')"
					:placeholder="`${$t('Actions.Choose')} ${$t('Student').toLowerCase()}`"
					name="student"
					:multiple="false"
					v-model="student"
					:type="2"
					:for="'people'"
				/>
			</div>

			<!-- Room -->
			<div class="mt-6">
				<legend class="uppercase-first-letter text-solid-gray-1">{{ $t("Room") }}:</legend>
				<v-select
					clearable
					class="border-none w-full select-multiple"
					:placeholder="`${$t('Actions.Choose')} ${$t('Room').toLowerCase()}`"
					v-model="localValue.Department"
					name="type"
					:options="$store.state.departments"
					:multiple="false"
					:reduce="type => type.name"
					label="name"
				>
				</v-select>
			</div>

			<!-- Status -->
			<div class="mt-6">
				<legend class="uppercase-first-letter text-solid-gray-1">{{ $t("Status.Label") }}:</legend>
				<v-select
					clearable
					class="border-none w-full select-multiple"
					:placeholder="`${$t('Actions.Choose')} ${$t('Status.Label').toLowerCase()}`"
					v-model="localValue.TopicID"
					:options="[
						{ name: $t('Status.In'), value: 'KHUON_MAT_1' },
						{ name: $t('Status.Out'), value: 'KHUON_MAT_2' }
					]"
					:multiple="false"
					:reduce="status => status.value"
					label="name"
				>
				</v-select>
			</div>

			<!-- Confidence Min -->
			<div class="mt-6">
				<legend class="uppercase-first-letter text-solid-gray-1">{{ $t("ConfidenceMin") }}:</legend>
				<vs-input
					type="number"
					:placeholder="$t('ConfidenceMin')"
					v-model="localValue.ConfMin"
					class="w-full"
					:data-vv-as="$t('ConfidenceMin')"
					v-validate="'required|between:0,1'"
				/>
			</div>

			<!-- Confidence Max -->
			<div class="mt-6">
				<legend class="uppercase-first-letter text-solid-gray-1">{{ $t("ConfidenceMax") }}:</legend>
				<vs-input
					type="number"
					:placeholder="$t('ConfidenceMax')"
					v-model="localValue.ConfMax"
					class="w-full"
					:data-vv-as="$t('ConfidenceMax')"
					v-validate="'required|between:0,1'"
				/>
			</div>

			<!-- Classification -->
			<div class="mt-6">
				<legend class="uppercase-first-letter text-solid-gray-1">{{ $t("Classification") }}:</legend>
				<v-select
					clearable
					class="border-none w-full select-multiple"
					:placeholder="`${$t('Actions.Choose')} ${$t('Classification').toLowerCase()}`"
					v-model="localValue.Classification"
					name="type"
					:options="['Vip', 'Normal', 'Blacklist']"
					:multiple="false"
				>
				</v-select>
			</div>
		</PerfectScrollbar>

		<div slot="footer" class="flex items-center justify-center">
			<vs-button type="border" @click.stop="handleResetLocalFilter" class="w-full sm:w-2/5 mr-6 last:mr-0 font-bold">{{ $t("Actions.Reset") }}</vs-button>

			<vs-button @click.stop="onApplyFilter" class="w-full sm:w-2/5 mr-6 last:mr-0 font-bold">{{ $t("Actions.Apply") }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import constant from "@/utils/constant";

import vSelect from "vue-select";

export default {
	name: "ActivityFilter",
	inheritAttrs: false,
	components: { vSelect },
	props: {
		isDialogActive: {
			type: Boolean,
			required: true
		},
		activityFilterFlagValue: {
			type: Number,
			validator: prop => {
				if (prop) {
					return !!_.findKey(constant.ACTIVITY_FILTER_FLAG, flagValue => flagValue === prop);
				}
				return true;
			}
		},
		value: {
			type: Object
		}
	},
	emits: {
		onApplyFilter: {}
	},
	data() {
		const today = new Date();
		return {
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			},
			detectDate: [],
			departments: [],
			student: null,
		};
	},
	computed: {
		isDialogActiveLocal: {
			get() {
				return this.isDialogActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeDialog");
				}
			}
		},
		localValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		}
	},
	watch: {
		isDialogActiveLocal() {
			if (this.isDialogActiveLocal) {
				this.initFilterData();
			}
		},
		student() {
			if (this.student && this.student.name) {
				const match = this.student.name.match(/\(([^)]+)\)/);
				this.localValue.PersonID = match ? match[1] : null;
			} else {
				this.$helper.notifyError({
					context: this,
					options: {
						title: this.$t('StudentNotFound'),
						text: this.$t('PleaseCheckStudentCodeBetweenTwoSystems')
					}
				});
			}
		},
	},
	methods: {
		onApplyFilter() {
			this.$emit("onApplyFilter", this.localValue);
		},
		initFilterData() {},
		handleResetLocalFilter() {
			const today = new Date();
			this.detectDate = [];
			this.student = null;
			this.localValue = {
				EventType: "Face",
				IsInRoi: true,
				DateStart: new Date(
					today.getFullYear(),
					today.getMonth(),
					today.getDate(),
					0,
					0,
					0
				),
				DateEnd: new Date(
					today.getFullYear(),
					today.getMonth(),
					today.getDate() + 1,
					0,
					0,
					0
				),
				StartIndex: this.limit * (this.currentPage - 1),
				EndIndex: this.limit * this.currentPage,
				HourOffset: 7,
				SortBy: "time",
				SortDirection: "desc",
				PersonID: null,
				PersonName: null,
				Classification: null,
				ConfMax: null,
				ConfMin: null,
				Department: null,
			};
		},
		changeDetectDate(data) {
			this.localValue.DateStart = new Date(data);
			this.localValue.DateEnd = moment(new Date(data)).add(1, "day").toDate();
		},
	}
};
</script>

<style lang="scss" scoped>
.custom-dialog.filter-dialog {
	::v-deep .el-dialog {
		margin-right: 0 !important;
	}
}

.request-filter {
	.request-filter__item {
		&:not(:last-child) {
			margin-right: 15px;
		}

		::v-deep .vs__dropdown-menu {
			top: initial;
		}
	}
}

.dialog-fade-enter-active {
	animation: dialog-fade-in 0.2s ease-in-out;
}

.dialog-fade-leave-active {
	animation: dialog-fade-out 0.5s ease-in-out;
}

@keyframes dialog-fade-in {
	0% {
		opacity: 0;
		transform: translateX(100%);
	}
	100% {
		opacity: 1;
		transform: translateX(0);
	}
}

@keyframes dialog-fade-out {
	0% {
		opacity: 1;
		transform: translateX(0);
	}
	100% {
		opacity: 0;
		transform: translateX(100%);
	}
}
</style>
